export default "__VITE_ASSET__BN5zRXi5__"